import type {ReactNode} from 'react';

import NetworkStatusWithQuality from '@/components/molecules/NetworkStatusWithQuality';

const NetWorkProvider = ({children}: {children: ReactNode}) => (
  <>
    <NetworkStatusWithQuality />
    {children}
  </>
);

export default NetWorkProvider;
